import { render, staticRenderFns } from "./BudgetSidebarSendBudget.vue?vue&type=template&id=242b9529&"
import script from "./BudgetSidebarSendBudget.vue?vue&type=script&lang=js&"
export * from "./BudgetSidebarSendBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports